import React from "react";
import "./CustomButtonStyle.scss";

const CustomButton = ({
  type = "button",
  buttonType,
  className,
  startIconClass,
  endIconClass,
  iconClass,
  label,
  children,
  startIcon,
  endIcon,
  icon,
  disabled,
  onClick,
}) => {
  switch (buttonType) {
    case "primary": {
      return (
        <button
          type={type}
          className={`${className} base-btn primary-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    case "secondary": {
      return (
        <button
          type={type}
          className={`${className} base-btn secondary-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    case "tertiary": {
      return (
        <button
          type={type}
          className={`${className} base-btn tertiary-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    case "quaternary": {
      return (
        <button
          type={type}
          className={`${className} base-btn quaternary-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    case "black": {
      return (
        <button
          type={type}
          className={`${className} base-btn black-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    case "grey": {
      return (
        <button
          type={type}
          className={`${className} base-btn grey-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }

    default: {
      return (
        <button
          type={type}
          className={`${className} base-btn default-btn`}
          disabled={disabled}
          onClick={onClick}
        >
          {
            (startIcon = startIcon
              ? React.isValidElement(startIcon)
                ? React.cloneElement(startIcon, {
                    className: `${startIconClass || ""} start-icon`,
                  })
                : startIcon
              : undefined)
          }
          {
            (icon = icon
              ? React.isValidElement(icon)
                ? React.cloneElement(icon, {
                    className: `${iconClass || ""} icon`,
                  })
                : icon
              : undefined)
          }
          {label}
          {children}
          {
            (endIcon = endIcon
              ? React.isValidElement(endIcon)
                ? React.cloneElement(endIcon, {
                    className: `${endIconClass || ""} end-icon`,
                  })
                : endIcon
              : undefined)
          }
        </button>
      );
    }
  }
};

export default CustomButton;
